import { get } from 'lodash';
import React from 'react';
import { Input } from 'src/components/Antd';
import DragNDropColumns from 'src/components/DragNDropColumns';
import { DeleteIcon } from 'src/components/Icon';
import { Item as ItemWrapper } from 'src/components/Layouts';
import { Field, antdErrorDisplayAdaptor } from 'src/components/RcForm';
import {
  checkResponsiveContentPageTab,
  checkResponsivePosterTab,
  checkResponsiveProductTab,
} from 'src/constrains/SalesChannelContent-Revamp/ModuleList/validator';
import { useI18n } from 'src/hooks/useRouterChange';
import { tabs as tK, title as titleK } from 'src/tools/contentModulesFieldName';
import { i18nGet } from 'src/tools/tools';
import { EnumModuleType } from 'src/types/common/module';
import css from './css.module.less';
const AllTabs = (props) => {
  const i18n = useI18n();
  const getI18n = (str) => i18nGet(i18n, str);
  const {
    disabled,
    draggableId,
    onSort,
    onAdd,
    onDelete,
    moduleType,
    breakpoint,
  } = props;
  const validator = () => {
    if (moduleType === EnumModuleType.ResponsivePosterTab) {
      const { checkTabTitleError } = checkResponsivePosterTab();
      return checkTabTitleError;
    }
    if (moduleType === EnumModuleType.ResponsiveProductTab) {
      const { checkTabTitleError } = checkResponsiveProductTab();
      return checkTabTitleError;
    }
    if (moduleType === EnumModuleType.ResponsiveContentTab) {
      const { checkTabTitleError } = checkResponsiveContentPageTab();
      return checkTabTitleError;
    }
  };
  return (
    <Field name={tK}>
      {(p, meta) => {
        const { value, onChange } = p;

        const onlyLastTab = (value || []).length === 1;
        const length = (value || []).length;

        const handleOnSort = (obj) => {
          const { data } = obj;
          const { newIndex, oldIndex } = data || {};
          onSort(value, onChange, oldIndex, newIndex);
        };
        const handleOnDelete = (index) => {
          onDelete(value, onChange, index);
        };
        const handleOnAdd = () => {
          onAdd(value, onChange, length);
        };

        const childGenerate = (data, index) => {
          // const { title, draggableId } = data;
          return (
            <div className={css.tabContainer}>
              <ItemWrapper
                size='small'
                titleClassName={css.titleContainer}
                title={
                  <div className={css.titleTitleContainer}>
                    {getI18n('general.tabTitle')}
                    {!onlyLastTab && (
                      <DeleteIcon
                        onDelete={() => {
                          handleOnDelete(index);
                        }}
                      />
                    )}
                  </div>
                }>
                <Field
                  name={[tK, index, titleK]}
                  rules={[
                    {
                      // validateTrigger: 'onSubmit',
                      validator: async (rules: any, value: any) => {
                        const cF = validator();
                        if (cF) {
                          const res = cF(value, { breakpoint });
                          const hasError = get(res, 'hasError');
                          const errors = get(res, 'errors');
                          if (hasError) {
                            return Promise.reject(
                              new Error((errors || []).join(',')),
                            );
                            //</ItemWrapper>throw Error((errors || []).join(','));
                          }
                        }
                      },
                    },
                  ]}>
                  {(p, m) => {
                    const eP = antdErrorDisplayAdaptor(m);
                    const { value, onChange } = p;
                    return (
                      <Input
                        disabled={disabled}
                        size='large'
                        maxLength={100}
                        value={value}
                        onChange={onChange}
                        {...eP}
                        // {...m}
                      />
                    );
                  }}
                </Field>
              </ItemWrapper>
            </div>
          );
        };

        return (
          <DragNDropColumns
            disabled={disabled}
            // hideAdd={!isPrimary}
            // hideTitle
            titleRightTextClassName={css.tabAddText}
            title={getI18n('general.allTabs')}
            childGenerate={childGenerate}
            data={value || []}
            droppableId={`salesChannelContentListPosterTab${draggableId}`}
            onSort={handleOnSort}
            hideAdd
            hideTitleRightFunction={disabled}
            titleRightText={`+ ${getI18n('general.addTab')}`}
            titleRightFunction={handleOnAdd}
          />
        );
      }}
    </Field>
  );
};
export default AllTabs;
